import type { CaptureOptions, Properties } from 'posthog-js';
import posthog, { isPostHogEnabled } from '@host/config/posthog.ts';

export const trackEvent = (event: string, properties?: Properties, options?: CaptureOptions) => {
  if (isPostHogEnabled) posthog.capture(event, properties, options);
};
